import React from 'react';
import { Button } from '@visalex/core';

import styles from '../FreeConsultation/FreeConsultation.module.scss';

export type QuestionnaireActionFooterProps = {
  text: string;
  isLoading: boolean;
};

export const QuestionnaireActionFooter = ({ text, isLoading }: QuestionnaireActionFooterProps) => {
  return (
    <div className="d-flex flex-column align-items-center ml-auto">
      <Button className={styles['action-button']} type="submit" size="lg" loading={isLoading}>
        {text}
      </Button>
    </div>
  );
};
